"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeBannerRoot = exports.MobileLinks = exports.LinksRoot = exports.DesktopLinks = exports.CopyrightRoot = exports.CenteredRoot = void 0;
var _mui = require("@ori-ui/mui");
const CenteredRoot = exports.CenteredRoot = (0, _mui.styled)('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'white'
});
const CopyrightRoot = exports.CopyrightRoot = (0, _mui.styled)(CenteredRoot)({
  height: '40px'
});
const LinksRoot = exports.LinksRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  display: 'grid',
  rowGap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(150px, 1fr)',
    justifyContent: 'center',
    justifyItems: 'center',
    columnGap: theme.spacing(3)
  }
}));
const SubscribeBannerRoot = exports.SubscribeBannerRoot = (0, _mui.styled)(CenteredRoot)({
  height: 70
});
const MobileLinks = exports.MobileLinks = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'contents',
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}));
const DesktopLinks = exports.DesktopLinks = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'contents'
  }
}));